import { render, staticRenderFns } from "./PatentSpecification.vue?vue&type=template&id=0e752e3c&scoped=true"
import script from "./PatentSpecification.vue?vue&type=script&setup=true&lang=ts"
export * from "./PatentSpecification.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PatentSpecification.vue?vue&type=style&index=0&id=0e752e3c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e752e3c",
  null
  
)

export default component.exports